// extracted by mini-css-extract-plugin
module.exports = {"embla__slide":"video-testimonial-carousel_embla__slide__l1_hr"};